import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import Link from 'valuelink';
import { Popconfirm, message, Button, DatePicker } from 'antd';
import { Input } from 'valuelink/lib/tags';
import moment from 'moment';
import { RegularText, SemiboldText } from '../../components/common/Text';
import { setDoctorProfile } from '../../actions/index';
import {
  fetchDoctorEducation,
  deleteEducation,
  updateEducation,
} from '../../services';

const { RangePicker } = DatePicker;

const OuterContainer = styled.div`
  display: flex;
  flex: 1 0;
  flex-direction: column;
  justify-content: center;
  /* align-items: center; */
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
`;

const TitleText = styled(SemiboldText)`
  font-size: 1.5rem;
  text-align: center;
  color: #666569;
`;

const ColContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const BodyContainer = styled.div`
  display: flex;
  flex: 1 0;
  flex-direction: column;
  align-items: stretch;
  margin-bottom: 20px;
  /* over */
`;

const StyledInputBox = styled(Input)`
  font-size: 16px !important;
  background-color: #f8f8f8;
  align-self: stretch;
  border-radius: 6px;
  flex: 1;
  flex-shrink: 0;
  min-width: 180px;
  /* max-width: 380px; */
  height: 44px;
  padding: 6px 12px;
  align-items: center;
`;

const LabelText = styled(SemiboldText)`
  font-size: 12px;
  text-align: center;
  margin-bottom: 0.25rem;
  margin-top: 0.625rem;
  color: #7c7c7c;
  display: flex;
  flex-shrink: 0;
  flex-direction: row;
`;

const EducationRow = styled.div`
  display: flex;
  flex-direction: row;
  margin: 16px;
  padding: 8px;
  box-shadow: 0 3px 5px 2px rgba(0, 0, 0, 0.1);
  border-radius: 0.5rem;
  align-items: center;
  justify-content: space-between;
`;

const EducationNumber = styled(SemiboldText)`
  font-size: 16;
  color: #666569;
`;

const EducationInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

const EducationText = styled(RegularText)`
  font-size: 14;
  color: #666569;
  margin: 0px 10px 0px 10px;
`;

const EduRowComponent = styled.div`
  display: flex;
  flex-direction: row;
`;

class DoctorBasicProfileScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      education: [],
      doctorEducationId: null,
      title: '',
      course: '',
      institution: '',
      passingYear: '',
      fromDate: '',
      toDate: '',
      formEditing: false,
    };
    console.log({ props });

    this.doctorId = props.doctorId;
  }

  componentDidMount = () => {
    this.fetchEducation();
  };

  fetchEducation = () => {
    const { dispatch } = this.props;
    fetchDoctorEducation(this.doctorId).then(res => {
      const education = res.data;
      dispatch(setDoctorProfile({ education }));
      this.setState({
        education,
      });
    });
  };

  submit = () => {
    const {
      doctorEducationId,
      title,
      course,
      institution,
      passingYear,
      fromDate,
      toDate,
    } = this.state;

    updateEducation({
      doctorId: this.doctorId,
      doctorEducationId,
      title,
      course,
      institution,
      passingYear: passingYear.toString(),
      fromDate,
      toDate,
    })
      .then(() => {
        this.cancelEditing();
        this.fetchEducation();
      })
      .catch(err => {
        console.log({ err });
      });
  };

  deleteEducation = doctorEducationId => {
    deleteEducation(this.doctorId, doctorEducationId)
      .then(() => {
        message.success('Education deleted successfully');
        this.fetchEducation();
      })
      .catch(err => {
        console.log({ err });
      });
  };

  editEducation = edu => {
    this.setState({
      formEditing: true,
      doctorEducationId: edu.doctorEducationId,
      title: edu.title || '',
      course: edu.course || '',
      institution: edu.institution || '',
      passingYear: edu.passingYear || '',
      fromDate: edu.fromDate || '',
      toDate: edu.toDate || '',
    });
  };

  cancelEditing = () => {
    this.setState({
      formEditing: false,
      doctorEducationId: null,
      title: '',
      course: '',
      institution: '',
      passingYear: '',
      fromDate: '',
      toDate: '',
    });
  };

  onFromToDateChange = (date, dateString) => {
    console.log({ date, dateString });
    this.setState({
      fromDate: dateString[0],
      toDate: dateString[1],
    });
  };

  render() {
    const { education } = this.state;
    const titleLink = Link.state(this, 'title');
    const courseLink = Link.state(this, 'course');
    const institutionLink = Link.state(this, 'institution');
    const passingYearLink = Link.state(this, 'passingYear');

    const educationForm = () => {
      console.log({ state: this.state });
      return (
        <EducationRow>
          <BodyContainer>
            <LabelText>Education Title</LabelText>
            <StyledInputBox
              className="visit-input"
              valueLink={titleLink}
              placeholder="Title"
            />

            <LabelText>Course</LabelText>
            <StyledInputBox
              className="visit-input"
              valueLink={courseLink}
              placeholder="Course"
            />

            <LabelText>Institution</LabelText>
            <StyledInputBox
              className="visit-input"
              valueLink={institutionLink}
              placeholder="Institution"
            />

            <LabelText>Passing Year</LabelText>
            <StyledInputBox
              type="tel"
              className="visit-input"
              valueLink={passingYearLink}
              placeholder="Passing Year"
              maxLength={4}
            />

            <LabelText>From Date - To Date</LabelText>
            <RangePicker
              onChange={this.onFromToDateChange}
              style={{ marginBottom: 20 }}
              defaultValue={
                this.state.fromDate
                  ? [
                      moment(this.state.fromDate, 'YYYY-MM-DD'),
                      moment(this.state.toDate, 'YYYY-MM-DD'),
                    ]
                  : null
              }
            />

            <EduRowComponent>
              <Button
                type="primary"
                style={{ marginRight: 10 }}
                onClick={this.submit}
              >
                Submit
              </Button>
              <Button onClick={this.cancelEditing}>Cancel</Button>
            </EduRowComponent>
          </BodyContainer>
        </EducationRow>
      );
    };

    const renderEducation = (edu, idx) => (
      <EducationRow>
        <EduRowComponent>
          <EducationNumber>{idx + 1}. </EducationNumber>
          <EducationInfo>
            <EducationText>{edu.title}</EducationText>
            <EducationText>{`Passing Year: ${edu.passingYear}`}</EducationText>
          </EducationInfo>
        </EduRowComponent>
        <EduRowComponent>
          <Button
            type="primary"
            style={{ marginRight: 10 }}
            onClick={() => this.editEducation(edu)}
          >
            Edit
          </Button>
          <Popconfirm
            title="Are you sure delete this?"
            onConfirm={() => this.deleteEducation(edu.doctorEducationId)}
            // onCancel={cancel}
            okText="Yes"
            cancelText="No"
          >
            <Button type="danger">Delete</Button>
          </Popconfirm>
        </EduRowComponent>
      </EducationRow>
    );

    return (
      <OuterContainer>
        <TitleText>Doctor Education Screen</TitleText>
        <ColContainer>{education.map(renderEducation)}</ColContainer>
        {!this.state.formEditing && (
          <Button
            style={{ alignSelf: 'center', flex: 0, padding: 4 }}
            onClick={() => this.editEducation({})}
          >
            Add Education
          </Button>
        )}
        {this.state.formEditing && educationForm()}
      </OuterContainer>
    );
  }
}

const mapStateToProps = state => ({
  authToken: state.user.authToken,
});

export default connect(mapStateToProps)(DoctorBasicProfileScreen);
